import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { bannerSlides } from '@/mocks/banners';

export default function HeroCarousel() {
  const [current, setCurrent] = useState(0);
  const total = bannerSlides.length;

  useEffect(() => {
    const timer = window.setInterval(() => {
      setCurrent((prev) => (prev + 1) % total);
    }, 5000);
    return () => window.clearInterval(timer);
  }, [total]);

  const go = (dir: number) => setCurrent((prev) => (prev + dir + total) % total);
  const slide = bannerSlides[current];

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden bg-secondary-900">
      {bannerSlides.map((item, index) => (
        <div
          key={item.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={item.image}
            alt={`${item.title} 推荐海报`}
            title={`${item.title} - 在线观看`}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/45 to-black/20"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>

      <div className="relative z-10 w-full h-full flex items-center">
        <div className="w-full px-6 md:px-16">
          <div className="max-w-2xl animate-fade-up" key={slide.id}>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold mb-4">
              <i className="ri-fire-fill"></i>
              {slide.tag}
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-4">{slide.title}</h2>
            <p className="text-sm md:text-base text-background-100/90 leading-relaxed mb-8 max-w-xl">
              {slide.tagline}
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to={`/detail/${slide.videoId}`}
                className="inline-flex items-center justify-center gap-2 h-11 px-7 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-fill text-lg"></i>
                立即观看
              </Link>
              <Link
                to="/category/movie"
                className="inline-flex items-center justify-center gap-2 h-11 px-7 rounded-md bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium backdrop-blur transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-compass-3-line text-lg"></i>
                浏览全部
              </Link>
            </div>
          </div>
        </div>
      </div>

      <button
        type="button"
        aria-label="上一张"
        onClick={() => go(-1)}
        className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 z-20 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/35 text-background-50 backdrop-blur transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-2xl"></i>
      </button>
      <button
        type="button"
        aria-label="下一张"
        onClick={() => go(1)}
        className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 z-20 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/35 text-background-50 backdrop-blur transition-colors cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-2xl"></i>
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2">
        {bannerSlides.map((item, index) => (
          <button
            key={item.id}
            type="button"
            aria-label={`切换到第${index + 1}张`}
            onClick={() => setCurrent(index)}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${
              index === current ? 'w-8 bg-accent-500' : 'w-3 bg-background-50/50'
            }`}
          ></button>
        ))}
      </div>
    </section>
  );
}